<script lang="ts">
  import {page} from '$app/stores';

  import {Wrap} from '$lib/components/wrap';

  $: status = $page.status;
  $: error = $page.error;
  $: isServerError = /^5/.test(`${status}`);
  $: if (isServerError) {
    console.error(status, error);
  }
</script>

<Wrap>
  {#if status === 404}
    <h1>Oops!</h1>

    We can't find the page you're looking for. Please use the navigation to
    navigate to safety
  {:else if isServerError}
    <h1>Oops!</h1>

    We've had a server error. If the issue persists, please let us know.
  {:else}
    <h1>Oops we get a {status} error</h1>

    {error.message}
  {/if}
</Wrap>
